import { ReactNode } from "react";
import styled from "@emotion/styled";

export type ActionIconProps = {
    icon: ReactNode;
};

const StyledIconWrapper = styled("span")(({ theme }) => ({
    height: theme.spacing(3),
    width: theme.spacing(3),
    minWidth: theme.spacing(3),
    padding: theme.spacing(0.5),
    paddingRight: 0,
    display: "flex",
    alignItems: "center",
    boxSizing: "content-box",
    color: theme.kaltura.palette.primary.main,
}));

const ActionIcon = ({ icon, ...other }: ActionIconProps) => {
    if (!icon) {
        return null;
    }

    return <StyledIconWrapper>{icon}</StyledIconWrapper>;
};

export default ActionIcon;
